import AddressAppResource from './AddressAppResource';
import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import CalendarAppResource from './CalendarAppResource';
import CalendarEventAttendeeAppResource from './CalendarEventAttendeeAppResource';
import CalendarEventCategoryAppResource from './CalendarEventCategoryAppResource';
import CalendarEventStatusAppResource from './CalendarEventStatusAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import PropertyAppResource from './PropertyAppResource';
import StageAppResource from './StageAppResource';
import WorkspaceAppResource from './WorkspaceAppResource';
import WorkspaceOrganizationMemberAppResource from './WorkspaceOrganizationMemberAppResource';
import CalendarEventReminderAppResource from "./CalendarEventReminderAppResource";
import FileAppResource from "./FileAppResource";
import KnowledgeAssetArticleAppResource from "./KnowledgeAssetArticleAppResource";
import TaskAppResource from "./TaskAppResource";
import DateTimeHelper from "../Helpers/DateTimeHelper";
import StageTypeAppResource from "./StageTypeAppResource";
import KnowledgeAssetVideoAppResource from "./KnowledgeAssetVideoAppResource";
import ResourceAppResource from "./ResourceAppResource";
import KnowledgeAssetAppResource from "./KnowledgeAssetAppResource";

class CalendarEventAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'calendar-event';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'calendar-events';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'subject',
            'description',
            'timeStart',
            'timeEnd',
            'duration',
            'isAllDay',
            'plainLocation',
            'locationAddressUuid',
            'calendarUuid',
            'ownerWorkspaceOrganizationMemberUuid',
            'workspaceUuid',
            'organizationUuid',
            'stageUuid',
            'stageTypeUuid',
            'calendarEventCategoryUuid',
            'calendarEventStatusUuid',
            'meta',
            'propertyUuid',
            'calendar',
            'locationAddress',
            'ownerWorkspaceOrganizationMember',
            'workspace',
            'organization',
            'stage',
            'stageType',
            'property',
            'calendarEventCategory',
            'calendarEventStatus',
            'attendees',
            'reminders',
            'files',
            'conferenceLink',
            'assets',
            'parentCalendarEventUuid',
            'parentTaskUuid',
            'differenceBetweenDates',
            'parentTask',
            'parentEvent',
            'videoAssets',
            'serviceProviderResources',
            'formsetResources',
            'knowledgeAssets',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            locationAddress: AddressAppResource,
            calendar: CalendarAppResource,
            ownerWorkspaceOrganizationMember: WorkspaceOrganizationMemberAppResource,
            workspace: WorkspaceAppResource,
            organization: OrganizationAppResource,
            stage: StageAppResource,
            stageType: StageTypeAppResource,
            property: PropertyAppResource,
            calendarEventCategory: CalendarEventCategoryAppResource,
            calendarEventStatus: CalendarEventStatusAppResource,
            attendees: CalendarEventAttendeeAppResource,
            reminders: CalendarEventReminderAppResource,
            files: FileAppResource,
            assets: KnowledgeAssetArticleAppResource,
            parentTask: TaskAppResource,
            parentEvent: CalendarEventAppResource,
            childrenTasks: TaskAppResource,
            childrenEvents: CalendarEventAppResource,
            videoAssets: KnowledgeAssetVideoAppResource,
            serviceProviderResources: ResourceAppResource,
            formsetResources: ResourceAppResource,
            knowledgeAssets: KnowledgeAssetAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            locationAddress: 'location_address_uuid',
            calendar: 'calendar_uuid',
            ownerWorkspaceOrganizationMember: 'owner_workspace_organization_member_uuid',
            workspace: 'workspace_uuid',
            organization: 'organization_uuid',
            stage: 'stage_uuid',
            stageType: 'stage_type_uuid',
            property: 'property_uuid',
            calendarEventCategory: 'calendar_event_category_uuid',
            calendarEventStatus: 'calendar_event_status_uuid',
            parentEvent: 'parent_calendar_event_uuid',
            parentTask: 'parent_task_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            subject: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
            },
            timeStart: {
                presence: true,
                datetime: true,
            },
            timeEnd: {
                datetime: true,
            },
            duration: {
                numericality: true,
            },
            isAllDay: {
                type: 'boolean',
            },
            plainLocation: {
                type: 'string',
                length: {
                    maximum: 1000,
                },
            },
            calendarUuid: {
                type: 'string',
            },
            ownerWorkspaceOrganizationMemberUuid: {
                type: 'string',
                presence: true,
            },
            workspaceUuid: {
                type: 'string',
                presence: true,
            },
            organizationUuid: {
                type: 'string',
                presence: true,
            },
            calendarEventCategoryUuid: {
                type: 'string',
                presence: true,
            },
            calendarEventStatusUuid: {
                type: 'string',
            },
            locationAddressUuid: {
                type: 'string',
            },
            stageUuid: {
                type: 'string',
            },
            stageTypeUuid: {
                type: 'string',
            },
            propertyUuid: {
                type: 'string',
            },
            conferenceLink: {
                type: 'string',
            },
            parentCalendarEventUuid: {
                type: 'string',
            },
            parentTaskUuid: {
                type: 'string',
            },
            differenceBetweenDates: {
                type: 'integer',
            },
            meta: {
            }
        };
    }

    getAPIDatetimeFormat() {
        return {
            timeStart: DateTimeHelper.apiDateTimeFormat,
            timeEnd: DateTimeHelper.apiDateTimeFormat
        }
    }

}

export default CalendarEventAppResource;
